import React from 'react';
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import moment from "moment";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import "./main-view.scss";
import { loadCalendarStatus, loadedCalendarStatus, openPrize, collectPrize } from "../store/actions/calendar";
import { doLogin } from "../../store/actions/authentication";
import { getText, styleToObj } from "../utils/functions";
import evBusMain from "../../utils/evbus";

import HeaderMobile from "../assets/header-mobile.jpg";
import HeaderDesktop from "../assets/header-desktop.jpg";
import PrizeCard from "../assets/prize-card.png";
import PrizeHeader from "../assets/prize-header.jpg";
import PrizesInfoDesktop from "../assets/prize-desktop.png";
import PrizesInfoMobile from "../assets/prize-mobile.png";
import Icons from "../../assets/Icons/Icons";
import Today from "../assets/today.png";
import ChoosePrize from '../assets/icon-choose-prize.svg'
import ChoosePrizeDialog from "../components/choose-prize-dialog";

import BonusImage from "../assets/bonus-image.png";
import RaffleImage from "../assets/raffle-image.png";

const interceptClickEvent = (e) => {
  let target = e.target || e.srcElement;

  if (window.config.cordova) {
    if (target.tagName === 'A') {
      const href = target.getAttribute('href');

      if (href.indexOf("http") === 0) {
        e.preventDefault();
        window.cordova.InAppBrowser.open(href, '_system');
        return;
      }
    } else {
      if (target.tagName !== 'A') {
        while (target.parentNode) {
          target = target.parentNode;
          if (target.tagName === 'A')
            break;
        }
        if (target.tagName !== 'A')
          return;

        const href = target.getAttribute('href');

        if (href.indexOf("http") === 0) {
          e.preventDefault();
          window.cordova.InAppBrowser.open(href, '_system');
          return;
        }
      }
    }
  }
};

const generateDateRange = (language) => {
  const months = {
    '1': 'Ian',
    '2': 'Feb',
    '3': 'Mar',
    '4': 'Apr',
    '5': 'Mai',
    '6': 'Iun',
    '7': 'Iul',
    '8': 'Aug',
    '9': 'Sept',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec'
  };

  const currentDate = moment().startOf('day');
  const dateRange = [];

  for (let i = -5; i <= 5; i++) {
    const date = currentDate.clone().add(i, 'days');
    dateRange.push({
      number: date.format('D'),
      title: language === 'ro' ? months[date.format('M')] : date.format('MMM'),
      current: i === 0,
    });
  }

  return dateRange;
};

const MainView = (props) => {
  const {
    authentication, calendarStatus, calendarLoading,
    loadCalendarStatus, doLogin, t, history, i18n,
    fromDialog, onClose, openPrize, collectPrize,
  } = props;

  const rootRef = React.useRef(null);
  const [openDialog, setOpenDialog] = React.useState(false);
  const handleDialogClose = (closeMainViewDialog) => {
    if (closeMainViewDialog && typeof onClose === "function") return onClose();
    setOpenDialog(false);
  };

  const handleOpen = () => {
    if (calendarStatus?.current_prize?.opened === false) {
      openPrize(calendarStatus.current_prize.id);
    }
  };

  const handleCollect = () => {
    if (calendarStatus?.current_prize?.collected === false) {
      collectPrize(calendarStatus?.current_prize?.id);
    }
  };

  React.useEffect(() => {
    loadCalendarStatus();
  }, []); // eslint-disable-line

  React.useEffect(() => {
    if (window.config.cordova) {
      let element = null;
      if (rootRef.current) {
        element = rootRef.current;
        element.addEventListener("click", interceptClickEvent, false);
      }

      return () => {
        if (element) {
          element.removeEventListener("click", interceptClickEvent, false);
        }
      }
    }
  }, [rootRef]);

  React.useEffect(() => {
    if (["user", "token"].indexOf(authentication.auth_type) === -1 || authentication.access_token === null) {
      if (window.config.platformType === 2) {
        localStorage.setItem("redirect_after_login", "/promo-calendar");
        // mobile - do a redirect
        if (window.config.cordova) {
          evBusMain.emit("TRY-FACE-UNLOCK-LOGIN");
        } else {
          history.push("/connect");
        }
      } else {
        // web - show modal
        evBusMain.emit("CLOSE-PROMO-CALENDAR-DIALOG");
        doLogin();
      }
      return;
    }

    if (!calendarLoading && calendarStatus) {
      if (calendarStatus && calendarStatus.campaign) {
        if (calendarStatus.campaign.start_time && calendarStatus.campaign.end_time) {
          const now = moment().valueOf();
          const start_start = moment(calendarStatus.campaign.start_time).valueOf();
          const end_date = moment(calendarStatus.campaign.end_time).valueOf();

          if (!(start_start <= now && now <= end_date)) {
            if (window.config.platformType === 1) {
              evBusMain.emit("CLOSE-PROMO-CALENDAR-DIALOG");
            }
            history.push("/");
            return;
          }
        }
      }

    }
  }, [calendarStatus, calendarLoading, authentication, doLogin, history]);

  const handleClose = () => {
    if (typeof onClose === "function") return onClose();
    props.history.push("/");
  };

  const handleClaim = () => {
    handleCollect();
    props.history.push(`/profile/wallet`);
  }

  const handleDeposit = () => {
    handleCollect();
    if (calendarStatus?.current_prize?.meta?.is_deposit) {
      let bonusId = '';
      const bonusIds = [];

      if (calendarStatus?.current_prize?.meta?.bonuses) {
        const bonuses = calendarStatus?.current_prize?.meta?.bonuses;;
        if (Array.isArray(bonuses) && bonuses.length > 0) {
          bonuses.forEach(bonus => {
            if (bonus?.bonus_preset_id) {
              bonusIds.push(bonus.bonus_preset_id);
            }
          });
        }
        if (bonusIds.length === 1) {
          bonusId = `#${bonusIds[0]}`;
        }
      }

      if (bonusIds.length === 1) {
        evBusMain.emit("CLOSE-PROMO-CALENDAR-DIALOG");
        props.history.push(`/deposit${bonusId}`);
      } else if (bonusIds.length > 1) {
        setOpenDialog(true);
      }
    }
  };

  let hasTwoBonuses = false;
  if (calendarStatus?.current_prize?.meta?.bonuses) {
    const bonuses = calendarStatus?.current_prize?.meta?.bonuses;;
    let bonusNo = 0;
    if (Array.isArray(bonuses) && bonuses.length > 0) {
      bonuses.forEach(bonus => {
        if (bonus?.bonus_preset_id) {
          bonusNo += 1;
        }
      });
    }
    if (bonusNo > 1) {
      hasTwoBonuses = true;
    }
  }

  const info = {
    header_mobile: calendarStatus?.campaign?.meta?.ui?.header_mobile ?? HeaderMobile,
    header_mobile_style: styleToObj(calendarStatus?.campaign?.meta?.ui?.header_mobile_style ?? ""),
    header_desktop: calendarStatus?.campaign?.meta?.ui?.header_desktop ?? HeaderDesktop,
    header_desktop_style: styleToObj(calendarStatus?.campaign?.meta?.ui?.header_desktop_style ?? ""),

    myTickets: calendarStatus?.player_campaign_data?.tickets ?? 0,
    missedDays: calendarStatus?.player_campaign_data?.missed_prizes ?? 0,
    totalDays: calendarStatus?.player_campaign_data?.max_missed_prizes ?? 0,
    collectedPrizes: calendarStatus?.player_campaign_data?.collected_prizes ?? 0,
    totalPrizes: calendarStatus?.campaign?.total_prizes ?? 0,
    youQualify: calendarStatus?.player_campaign_data?.missed_prizes <= calendarStatus?.player_campaign_data?.max_missed_prizes,
    days: generateDateRange(i18n.language),

    name: calendarStatus?.campaign?.meta?.ui?.name ?? {},

    cell1Value: calendarStatus?.campaign?.meta?.ui?.cell_1_value ?? {},
    cell1Text: calendarStatus?.campaign?.meta?.ui?.cell_1_text ?? {},
    cell2Value: calendarStatus?.campaign?.meta?.ui?.cell_2_value ?? {},
    cell2Text: calendarStatus?.campaign?.meta?.ui?.cell_2_text ?? {},
    cell3Value: calendarStatus?.campaign?.meta?.ui?.cell_3_value ?? {},
    cell3Text: calendarStatus?.campaign?.meta?.ui?.cell_3_text ?? {},
    cell4Value: calendarStatus?.campaign?.meta?.ui?.cell_4_value ?? {},
    cell4Text: calendarStatus?.campaign?.meta?.ui?.cell_4_text ?? {},

    rules: calendarStatus?.campaign?.meta?.ui?.rules ?? {},
  };

  let prize = {
    img: calendarStatus?.current_prize?.meta?.ui?.bonus_image ? calendarStatus?.current_prize?.meta?.ui?.bonus_image : BonusImage,
    title: calendarStatus?.current_prize?.meta?.ui?.bonus_title ?? {},
    subtitle: calendarStatus?.current_prize?.meta?.ui?.bonus_subtitle ?? {},

    img2: calendarStatus?.current_prize?.meta?.ui?.bonus_image_2 ? calendarStatus?.current_prize?.meta?.ui?.bonus_image_2 : BonusImage,
    title2: calendarStatus?.current_prize?.meta?.ui?.bonus_title_2 ?? {},
    subtitle2: calendarStatus?.current_prize?.meta?.ui?.bonus_subtitle_2 ?? {},

    tickets: calendarStatus?.current_prize?.meta?.tickets,
    raffleImage: calendarStatus?.current_prize?.meta?.ui?.tickets_image
      ? calendarStatus?.current_prize?.meta?.ui?.tickets_image
      : RaffleImage,
    ticketsTitle: calendarStatus?.current_prize?.meta?.ui?.tickets_title ?? {},
  };

  const inDialog = fromDialog;

  return <div className={`winter-promo-calendar ${inDialog ? 'in-dialog' : ''}`}>
    <div className="wpc-title">
      <div className='icon center' onClick={handleClose}>
        {!inDialog && Icons.get('arrowBack', 'ArrowBackIcon')}
      </div>
      <div className='title'>{getText(info, `name.${i18n.language}`, '')}</div>
      <div className='icon center' onClick={handleClose}>
        {inDialog && Icons.get('closeIcon', 'CloseIcon')}
      </div>
    </div>
    <div className="wpc-header">
      <div className="wpc-header-bg">
        {inDialog && <img src={info.header_desktop} alt="" style={info.header_desktop_style} />}
        {!inDialog && <img src={info.header_mobile} alt="" style={info.header_mobile_style} />}
      </div>
      <div className="wpc-header-info">
        <div className="col">
          <div className="title">{info.myTickets}</div>
          <div className="subtitle">{t("My Tickets")}</div>
        </div>
        {/* 
        <div className="col-sep"></div>
        <div className="col">
          <div className="title"><span className="red">{info.missedDays}</span> / {info.totalDays}</div>
          <div className="subtitle">{t("Missed days")}</div>
        </div>
        */}
        <div className="col-sep"></div>
        <div className="col">
          <div className="title">{info.collectedPrizes} / {info.totalPrizes}</div>
          <div className="subtitle">{t("Collected prizes")}</div>
        </div>
      </div>
    </div>

    <div className={`wpc-status yes center`}>
      <div>
        <React.Fragment>
          <CheckCircleIcon />
          {t("You qualify for the grand prize")}
        </React.Fragment>
      </div>
    </div>

    <div className="wpc-days-wrp">
      <div className="wpc-days center">
        {info.days.map((day, index) => {
          if (day.current) {
            return <div className="day current" key={index}>
              <img src={Today} alt="background" />
              <div className="day-number">{day.number}</div>
              <div className="day-title">{day.title}</div>
            </div>
          }

          if (day.empty) {
            return <div className="day empty" key={index}>&nbsp;</div>;
          }

          return <div className="day" key={index}>
            <div className="day-number">{day.number}</div>
            <div className="day-title">{day.title}</div>
          </div>
        })}
      </div>
    </div>
    <div className="wpc-prizes">
      <div className="body-wrp">
        {
          (calendarStatus?.current_prize?.opened === false)
          && <div className="wpc-prize">
            <div className="wpc-s-header">
              <div className="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <path d="M18.3799 8.19825L16.6427 3.38055C15.7502 0.9055 12.2498 0.905505 11.3573 3.38055L9.62005 8.19825C9.50756 8.51022 9.2161 8.72198 8.88463 8.73257L3.76587 8.89606C1.13616 8.98006 0.0545092 12.3091 2.13262 13.9227L6.17768 17.0637C6.43962 17.2671 6.55094 17.6097 6.45858 17.9283L5.03229 22.847C4.29955 25.374 7.13137 27.4314 9.30822 25.9537L13.5455 23.0772C13.8199 22.8909 14.1801 22.8909 14.4545 23.0772L18.6918 25.9537C20.8686 27.4314 23.7004 25.374 22.9677 22.847L21.5414 17.9283C21.4491 17.6097 21.5604 17.2671 21.8223 17.0637L25.8674 13.9227C27.9455 12.3091 26.8638 8.98006 24.2341 8.89606L19.1154 8.73257C18.7839 8.72198 18.4924 8.51022 18.3799 8.19825Z" stroke="#758BA0" strokeWidth="2" />
                </svg>
              </div>
              {t("Award of the Day")}
            </div>
            <div className="body">
              <div className="prize-image">
                <img src={PrizeCard} alt="Prize Card" />
              </div>
              <div className="prize-txt button" onClick={handleOpen}>
                {t("Open prize")}
              </div>
            </div>
          </div>
        }
        {
          calendarStatus?.current_prize?.opened
          && <div className="wpc-prize awarded">
            <div className="wpc-s-header">
              <div className="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <path d="M18.3799 8.19825L16.6427 3.38055C15.7502 0.9055 12.2498 0.905505 11.3573 3.38055L9.62005 8.19825C9.50756 8.51022 9.2161 8.72198 8.88463 8.73257L3.76587 8.89606C1.13616 8.98006 0.0545092 12.3091 2.13262 13.9227L6.17768 17.0637C6.43962 17.2671 6.55094 17.6097 6.45858 17.9283L5.03229 22.847C4.29955 25.374 7.13137 27.4314 9.30822 25.9537L13.5455 23.0772C13.8199 22.8909 14.1801 22.8909 14.4545 23.0772L18.6918 25.9537C20.8686 27.4314 23.7004 25.374 22.9677 22.847L21.5414 17.9283C21.4491 17.6097 21.5604 17.2671 21.8223 17.0637L25.8674 13.9227C27.9455 12.3091 26.8638 8.98006 24.2341 8.89606L19.1154 8.73257C18.7839 8.72198 18.4924 8.51022 18.3799 8.19825Z" stroke="#758BA0" strokeWidth="2" />
                </svg>
              </div>
              {t("Award of the Day")}
            </div>
            <div className="body">
              <div className="prize-header">
                <div className="image"><img src={PrizeHeader} alt="" /></div>
                <div className="texts">
                  <div className="date">{calendarStatus?.current_prize?.collect_start_time != null ? moment(calendarStatus?.current_prize?.collect_start_time).format("DD MMM YYYY") : null}</div>
                  <div className="title">{!calendarStatus?.current_prize?.awarded ? t("Your prize") : t("Congratulations!")}</div>
                  <div className="subtitle">{!calendarStatus?.current_prize?.awarded ? t("Prizes in waiting") : t("You have won these prizes!")}</div>
                </div>
              </div>
              <div className="prize-info">
                <div className={`p-text ${!hasTwoBonuses ? 'd-none' : ''}`}>
                  <div className="i"><img src={ChoosePrize} alt="" /></div>
                  <div className="t">
                    {t("Choose your daily bonus")}:
                  </div>
                </div>
                <div className="bonus">
                  <div className="bonus-image">
                    <img src={prize.img} alt="" />
                  </div>
                  <div className="texts">
                    <div className="bonus-title">
                      {getText(prize, `title.${i18n.language}`, '')}
                    </div>
                    <div className="bonus-subtitle">
                      {getText(prize, `subtitle.${i18n.language}`, '')}
                    </div>
                  </div>
                </div>
                <div className={`or ${!hasTwoBonuses ? 'd-none' : ''}`}>{t("or")}</div>
                <div className="bonus">
                  <div className="bonus-image">
                    <img src={prize.img2} alt="" />
                  </div>
                  <div className="texts">
                    <div className="bonus-title">
                      {getText(prize, `title2.${i18n.language}`, <span>&nbsp;</span>)}
                    </div>
                    <div className="bonus-subtitle">
                      {getText(prize, `subtitle2.${i18n.language}`, <span>&nbsp;</span>)}
                    </div>
                  </div>
                </div>
                <div className="sep">
                  <div className="sep-line"></div>
                  <div className="sep-text">+</div>
                  <div className="sep-line"></div>
                </div>
                <div className="raffle">
                  <div className="raffle-image">
                    <img src={prize.raffleImage} alt="" />
                  </div>
                  <div>
                    <div className="raffle-title">
                      <div className="title">
                        +{prize.tickets}
                      </div>
                      <div className="subtitle">
                        {getText(prize, `ticketsTitle.${i18n.language}`, '')}
                      </div>
                    </div>
                  </div>
                </div>
                {calendarStatus?.current_prize?.awarded && <div className="status-text"><CheckCircleIcon /> {t("The prize has been activated")}</div>}
                {!calendarStatus?.current_prize?.awarded &&
                  calendarStatus?.current_prize?.meta?.is_deposit &&

                  <div className="status-link" onClick={handleDeposit}>{!hasTwoBonuses ? t("Deposit now") : t('Choose prize')}</div>}
                {!calendarStatus?.current_prize?.awarded &&
                  !calendarStatus?.current_prize?.meta?.is_deposit
                  &&
                  <div className="status-link" onClick={handleClaim}>{t("Claim now")}</div>}

              </div>
            </div>
          </div>
        }
        <div className="wpc-prize tomorrow">
          <div className="wpc-s-header muted">{t("Tomorrow's prize")}</div>
          <div className="body">
            <div className="prize-image">
              <img src={PrizeCard} alt="Prize Card" />
            </div>
            <div className="prize-txt text">
              {t("Come back tomorrow")}
            </div>
          </div>
        </div>
        <div className="wpc-prize">
          <div className="wpc-s-header">&nbsp;</div>
          <div className="body">
            <div className="prize-image">
              <img src={PrizeCard} alt="Prize Card" />
            </div>
            <div className="prize-txt text">
              {t("We are preparing something special")}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="wpc-prizes-info">
      <div className="wpc-s-header">
        <div className="icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M17.6951 5.36585C17.8051 5.19382 17.8999 5.01205 17.9784 4.82253C18.1537 4.39937 18.2439 3.94583 18.2439 3.48781C18.2439 2.56278 17.8765 1.67564 17.2224 1.02155C16.5683 0.367464 15.6812 0 14.7561 0C13.5465 0 12.3864 0.48053 11.531 1.33588C11.3336 1.53327 11.1562 1.7469 11 1.97362C10.8439 1.7469 10.6664 1.53327 10.469 1.33588C9.61369 0.48053 8.45358 0 7.24394 0C6.31891 0 5.43178 0.367464 4.77769 1.02155C4.1236 1.67564 3.75613 2.56278 3.75613 3.48781C3.75613 4.15854 3.94934 4.80936 4.30492 5.36585H1.3415C0.896977 5.36585 0.536621 5.72621 0.536621 6.17073V10.4634C0.536621 10.9079 0.896977 11.2683 1.3415 11.2683H1.60979V19.0488C1.60979 19.8315 1.92072 20.5821 2.47418 21.1356C3.02764 21.6891 3.7783 22 4.56101 22H17.4391C18.2218 22 18.9724 21.6891 19.5259 21.1356C20.0793 20.5821 20.3903 19.8315 20.3903 19.0488V11.2683H20.6586C21.1031 11.2683 21.4634 10.9079 21.4634 10.4634V6.17073C21.4634 5.72621 21.1031 5.36585 20.6586 5.36585H17.6951ZM7.24394 1.60976C6.74585 1.60976 6.26816 1.80762 5.91596 2.15982C5.56375 2.51203 5.36589 2.98972 5.36589 3.48781C5.36589 3.98589 5.56375 4.46358 5.91596 4.81579C6.26816 5.16799 6.74585 5.36585 7.24394 5.36585H10.1952V4.56098C10.1952 3.77826 9.88423 3.02761 9.33077 2.47415C8.7773 1.92069 8.02665 1.60976 7.24394 1.60976ZM11.8049 5.36585H14.7561C15.0028 5.36585 15.247 5.31728 15.4748 5.2229C15.7027 5.12852 15.9097 4.99018 16.0841 4.81579C16.2585 4.64139 16.3968 4.43436 16.4912 4.2065C16.5856 3.97865 16.6342 3.73443 16.6342 3.48781C16.6342 2.98972 16.4363 2.51203 16.0841 2.15982C15.7319 1.80762 15.2542 1.60976 14.7561 1.60976C13.9734 1.60976 13.2228 1.92069 12.6693 2.47415C12.1158 3.02761 11.8049 3.77826 11.8049 4.56098V5.36585ZM19.8537 9.65854V6.97561H2.14638V9.65854H19.8537ZM3.21955 11.2683V19.0488C3.21955 19.4046 3.36088 19.7458 3.61245 19.9973C3.86403 20.2489 4.20523 20.3902 4.56101 20.3902H10.1952V11.2683H3.21955ZM11.8049 20.3902V11.2683H18.7805V19.0488C18.7805 19.4046 18.6392 19.7458 18.3876 19.9973C18.136 20.2489 17.7948 20.3902 17.4391 20.3902H11.8049Z" fill="#758BA0" />
          </svg>
        </div>
        {t("Total Prizes")}
      </div>
      <div className="body">
        <div className="image">
          {inDialog && <img src={PrizesInfoDesktop} alt="Prize Info Dektop" />}
          {!inDialog && <img src={PrizesInfoMobile} alt="Prize Info Mobile" />}
        </div>
        <div className="info">
          <div className="cell">
            <div className="title">{getText(info, `cell1Value.${i18n.language}`, '')}</div>
            <div className="subtitle">{getText(info, `cell1Text.${i18n.language}`, '')}</div>
          </div>
          <div className="cell">
            <div className="title">{getText(info, `cell2Value.${i18n.language}`, '')}</div>
            <div className="subtitle">{getText(info, `cell2Text.${i18n.language}`, '')}</div>
          </div>
          <div className="cell">
            <div className="title">{getText(info, `cell3Value.${i18n.language}`, '')}</div>
            <div className="subtitle">{getText(info, `cell3Text.${i18n.language}`, '')}</div>
          </div>
          <div className="cell">
            <div className="title">{getText(info, `cell4Value.${i18n.language}`, '')}</div>
            <div className="subtitle">{getText(info, `cell4Text.${i18n.language}`, '')}</div>
          </div>
        </div>
      </div>
    </div>
    <div className="wpc-rules">
      <div className="wpc-s-header">
        <div className="icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M18.3964 0.46072C18.691 0.75533 18.8567 1.15479 18.8571 1.57143V8.64286H17.2857V1.57143H1.57143V11.7857C1.57022 13.0678 1.91814 14.3261 2.57786 15.4254C3.23758 16.5248 4.18421 17.4237 5.31615 18.0259L8.64286 19.8V21.5812L4.576 19.4126C3.19257 18.6767 2.03566 17.578 1.22947 16.2343C0.423285 14.8906 -0.00174559 13.3527 5.38828e-06 11.7857V1.57143C0.000421406 1.15479 0.166116 0.75533 0.460726 0.46072C0.755335 0.16611 1.15479 0.000416017 1.57143 0H17.2857C17.7024 0.000416017 18.1018 0.16611 18.3964 0.46072ZM19.4126 11.2302L21.7698 13.5874C21.9171 13.7347 21.9998 13.9345 21.9998 14.1429C21.9998 14.3512 21.9171 14.551 21.7698 14.6984L14.4681 22H11V18.5319L18.3016 11.2302C18.449 11.0829 18.6488 11.0002 18.8571 11.0002C19.0655 11.0002 19.2653 11.0829 19.4126 11.2302ZM12.5714 20.4286H13.8176L17.7461 16.5L16.5 15.2539L12.5714 19.1824V20.4286ZM17.611 14.1429L18.8571 15.389L20.1033 14.1429L18.8571 12.8967L17.611 14.1429ZM12.5714 11H4.71428V12.5714H12.5714V11ZM14.1428 6.28571H4.71428V7.85714H14.1428V6.28571Z" fill="#758BA0" />
          </svg>
        </div>
        {t("Rules")}
      </div>
      <div className="body" dangerouslySetInnerHTML={{ __html: getText(info, `rules.${i18n.language}`, '') }} />
    </div>
    {openDialog && <ChoosePrizeDialog open={openDialog} onClose={handleDialogClose} />}
  </div>;
}

const mapState = (state) => {
  return {
    authentication: state.authentication,
    calendarStatus: state.promoCalendar?.calendar?.status ?? null,
    calendarLoading: state.promoCalendar?.calendar?.loading ?? false,
  };
};

const mapActions = {
  loadCalendarStatus,
  loadedCalendarStatus,
  openPrize,
  collectPrize,
  doLogin
};


export default withRouter(connect(mapState, mapActions)(withTranslation()(MainView)));